/**
 * JS mirror of --fontScale in marketplaceDefaults.css.
 * Import here for inline styles (e.g. Stripe Elements) and layout math that
 * cannot read CSS custom properties.
 */
export const FONT_SCALE = 1.25;

/** @param {number} basePx Pre-scale pixel value */
export const scaledFontSizePx = basePx => `${basePx * FONT_SCALE}px`;

/** Stripe card element typography — matches scaled marketplace input sizes. */
export const STRIPE_CARD_ELEMENT_FONT = {
  mobile: scaledFontSizePx(14),
  desktop: scaledFontSizePx(16),
  /** Used on desktop after resize; slightly larger than initial mount (legacy behavior). */
  desktopWide: scaledFontSizePx(18),
  lineHeight: scaledFontSizePx(24),
};
